import { useState } from 'react'
import { SystemSS } from '../../../components/SystemSS'
import { FullScreenModal } from '../../../utility/FullScreenModal'
export const FacilitiesDungeon = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
        console.log('clickd')
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            {' '}
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='confine'
                        src={`${process.env.PUBLIC_URL}/images/system/system-dungeon-fr.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        Si vous créez des donjons aléatoires et que vous les terminez,{' '}
                        <span className='text-pborange'>
                            vous pourrez faire monter de niveau vos unités, trouver des objets
                        </span>{' '}
                        et renforcer les Titres. Les donjons sont créés à l'aide d'une  <span className='text-pborange'>Carte</span>. Le nom de la Carte
                        détermine l'emplacement du donjon, les ennemis, les statistiques et les objets que vous pouvez
                        obtenir.
                    </p>{' '}
                    <br />
                    <p>
                        Quand vous créez un donjon aléatoire, vous pouvez librement choisir son Titre. Quand vous
                        terminerez ce donjon, vous recevrez en  <span className='text-pborange'>récompense</span> le titre créé.
                    </p>{' '}
                    <br />
                    <p>Veillez bien à monter le niveau de tous les Titres que vous créez !</p>
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'dungeon',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description='Quand vous créez un donjon et que vous le terminez, vous recevrez le nom que vous lui avez donné en tant que Titre. Essayez de créer vos propres Titres originaux !'
                    />{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'dungeon',
                                index: 2,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                    />{' '}
                    <p>
                        À mesure que vous progresserez d'étage en étage, le niveau des ennemis augmentera, ce qui
                         <span className='text-pborange'> renforcera</span> le Titre du donjon. De plus, les chances que  <span className='text-pborange'>des objets rares apparaissent
                        augmenteront également</span>.
                    </p>{' '}
                    <br />
                    <p>
                        En outre, des  <span className='text-pborange'>bonus d'étage</span> vous permettront d'obtenir encore plus d'EXP.  <span className='text-pborange'>Tous les</span> 10 étages, il
                        se peut aussi qu'un événement vous permette de tomber sur un Gadget qui n'apparaît que dans les
                        donjons : le Jack-pot. Il vous donnera une  <span className='text-pborange'>chance</span> de gagner encore plus d'EXP, de Mana ou de
                        BOR. Avec de la chance, vous pourrez même obtenir un objet rare. En revanche, si la malchance
                        vous frappe, quelque chose d'horrible risque de survenir. C'est tout de même une belle
                        opportunité de devenir riche et puissant !
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'dungeon',
                                index: 3,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                    />{' '}
                    <p>
                        Par contre, si vous êtes vaincu dans un donjon, vous perdrez tous les objets et EXP obtenus.
                        Plus vous progresserez, plus les ennemis deviendront puissants. Assurez-vous de <span className='text-pborange'>quitter le
                        donjon quand vous le pouvez</span>, ou de faire attention où vous mettez les pieds !
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'dungeon',
                                index: 4,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description={
                            "À part en terminant complètement chaque étage, vous ne pouvez quitter un donjon que si vous empruntez la sortie située tous les 10 étages, ou à tout moment grâce à la commande spéciale de l'Exploratrice : Retour. Vous avez aussi la possibilité de créer une sauvegarde temporaire dans les donjons aléatoires. Pour reprendre la partie, sélectionnez simplement « Continuer » sur l'écran titre."
                        }
                    />{' '}
                </div>{' '}
            </section>{' '}
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={4}
            />
        </>
    )
}
